module.exports = __webpack_public_path__ + "static/media/acmg-master-scheduler-edit-course.6830a19c.png";